import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { MessageCircle, Phone, Plus } from "lucide-react";
import { CONTACT } from "../constants";
import { useLanguage } from "../i18n/LanguageContext";

const FloatingContact = () => {
  const { t } = useLanguage();
  const [open, setOpen] = useState(false);

  const items = [
    {
      testId: "floating-whatsapp",
      href: CONTACT.whatsapp,
      label: t("floating.whatsapp"),
      icon: MessageCircle,
      cls: "bg-[#25D366] text-[#08080A]",
      external: true,
    },
    {
      testId: "floating-whatsapp-alt",
      href: CONTACT.whatsappAlt,
      label: t("floating.whatsappAlt"),
      icon: MessageCircle,
      cls: "bg-[#128C7E] text-white",
      external: true,
    },
    {
      testId: "floating-call-uae",
      href: CONTACT.uaeTel,
      label: `${t("floating.callUae")} · ${CONTACT.uaeDisplay}`,
      icon: Phone,
      cls: "bg-panel text-white border border-gold/25",
    },
    {
      testId: "floating-call-de",
      href: CONTACT.deTel,
      label: `${t("floating.callDe")} · ${CONTACT.deDisplay}`,
      icon: Phone,
      cls: "bg-panel text-white border border-gold/25",
    },
  ];

  return (
    <div className="fixed bottom-5 end-5 z-40 flex flex-col items-end gap-3 sm:bottom-7 sm:end-7">
      <AnimatePresence>
        {open && (
          <motion.div
            data-testid="floating-contact-menu"
            initial={{ opacity: 0, y: 14, scale: 0.94 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 14, scale: 0.94 }}
            transition={{ duration: 0.25, ease: "easeOut" }}
            className="flex flex-col gap-2.5"
          >
            {items.map((item) => (
              <a
                key={item.testId}
                data-testid={item.testId}
                href={item.href}
                {...(item.external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                onClick={() => setOpen(false)}
                className={`flex items-center gap-3 rounded-full py-3 pe-6 ps-4 text-xs font-bold uppercase tracking-wider shadow-2xl shadow-black/50 backdrop-blur-md transition-transform hover:scale-[1.03] ${item.cls}`}
              >
                <item.icon className="h-4 w-4" aria-hidden="true" />
                <span dir="auto">{item.label}</span>
              </a>
            ))}
          </motion.div>
        )}
      </AnimatePresence>

      <button
        type="button"
        data-testid="floating-contact-button"
        aria-label={t("floating.open")}
        aria-expanded={open}
        onClick={() => setOpen((o) => !o)}
        className={`flex h-14 w-14 items-center justify-center rounded-full shadow-2xl shadow-black/60 transition-all duration-300 ${
          open ? "rotate-45 bg-panel text-gold ring-1 ring-gold/40" : "animate-pulse-gold bg-gold text-[#08080A]"
        }`}
      >
        {open ? <Plus className="h-6 w-6" aria-hidden="true" /> : <MessageCircle className="h-6 w-6" aria-hidden="true" />}
      </button>
    </div>
  );
};

export default FloatingContact;
